"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Request = void 0;
class Request {
    constructor(url, session) {
        this.url = url;
        this.session = session;
        this.headers = {
            'Content-Type': 'application/json',
        };
    }
    getRequestInit(method, headers) {
        return {
            method,
            headers: { ...this.headers, ...headers },
        };
    }
    async handleResponse(response) {
        if ([200, 201].includes(response.status)) {
            return await response.json();
        }
        else {
            return Promise.reject(response);
        }
    }
    setHeaders(headers) {
        this.headers = { ...this.headers, ...headers };
    }
    async post(url, data = {}, config = {}) {
        const response = await fetch(url, {
            body: JSON.stringify(data),
            ...this.getRequestInit('POST', config.headers)
        });
        return this.handleResponse(response);
    }
    async get(url, config = {}) {
        const response = await fetch(url, this.getRequestInit('GET', config.headers));
        return this.handleResponse(response);
    }
    async track(event, properties) {
        this.session.initParams();
        return this.post(this.url, {
            event,
            properties,
            session_id: this.session.get(),
            shortId: this.session.getShortId(),
            utm: this.session.getUtm()
        });
    }
}
exports.Request = Request;
